// ── engineFormatter.js ───────────────────────────────────────────────────────
// Mirror of: backend/resultsEngine/formatter.js
// Keep both files in sync when changing formatting logic.

export function formatTime(seconds, precision) {
  if (precision === undefined) precision = 1;
  if (seconds == null) return '--';
  const totalMs = Math.round(seconds * 1000);
  const h = Math.floor(totalMs / 3600000);
  const m = Math.floor((totalMs % 3600000) / 60000);
  const s = Math.floor((totalMs % 60000) / 1000);
  const ms = totalMs % 1000;

  let result = '';
  if (h > 0) result += h + ':';
  result += (h > 0 ? String(m).padStart(2, '0') : m) + ':';
  result += String(s).padStart(2, '0');
  if (precision > 0) result += '.' + String(ms).padStart(3, '0').slice(0, precision);
  return result;
}

export function formatDiff(seconds, precision) {
  if (precision === undefined) precision = 1;
  if (seconds == null) return '--';
  if (seconds === 0) return '+0.' + '0'.repeat(precision);
  return '+' + formatTime(seconds, precision);
}
